import { lazy } from "react";
import type { FeatureRoute } from "../../app/route-types";

/** İK alanı: çalışan kayıtları, eksikler, içe aktarım ve raporlar. */
export const routes: FeatureRoute[] = [
  { path: "ik/calisanlar", Component: lazy(() => import("./EmployeesPage")) },
  { path: "ik/calisanlar/yeni", Component: lazy(() => import("./NewEmployeePage")) },
  { path: "ik/calisanlar/:id", Component: lazy(() => import("./EmployeePage")) },
  { path: "ik/eksikler", Component: lazy(() => import("./IssuesPage")) },
  { path: "ik/iceaktar", Component: lazy(() => import("./ImportPage")) },
  { path: "ik/raporlar", Component: lazy(() => import("./ReportsPage")) },
];
